<template>
	<v-card flat outlined class="wall-card">
		<v-card-title>
			{{ $vuetify.lang.t('$vuetify.views.wall.addNewPost.header') }}
		</v-card-title>
		<v-card-text class="pb-0">
			<div class="d-flex flex-row">
				<avatar hide-activity />
				<div class="new-post-activator ml-3" @click="$refs.newPost.showDialog()">
					{{ $vuetify.lang.t('$vuetify.views.wall.addNewPost.startTyping') }}...
				</div>
			</div>
		</v-card-text>
		<v-card-actions class="d-flex flex-wrap justify-content-between">
			<v-slide-group
				multiple
				show-arrows
				class="w-100"
			>
			<v-btn
				height="40"
				text
				class="wall-action-btn ml-auto mr-auto"
				style="padding-left: 10px !important; padding-right: 10px !important"
				@click="$refs.newPost.showDialog('image')"
			>
				<v-icon>$photo</v-icon> <span class="action-text">{{ $vuetify.lang.t('$vuetify.views.wall.addNewPost.buttons.addPhoto') }}</span>
			</v-btn>
			<v-btn
				height="40"
				text
				class="wall-action-btn mx-auto"
				style="padding-left: 10px !important; padding-right: 10px !important"
				@click="$refs.newPost.showDialog('video')"
			>
				<v-icon>$video</v-icon><span class="action-text">{{ $vuetify.lang.t('$vuetify.views.wall.addNewPost.buttons.addVideo') }}</span>
			</v-btn>
			<v-btn
				height="40"
				text
				class="wall-action-btn mx-auto"
				style="padding-left: 10px !important; padding-right: 10px !important"
				@click="$refs.newPost.showDialog('poll')"
			>
				<v-icon>$chart-bar</v-icon> <span class="action-text">{{ $vuetify.lang.t('$vuetify.views.wall.addNewPost.buttons.addPoll') }}</span>
			</v-btn>
			<v-btn
				height="40"
				text
				class="wall-action-btn mx-auto"
				style="padding-left: 10px !important; padding-right: 10px !important"
				@click="$refs.newPost.showDialog('problem')"
			>
				<v-icon>$help</v-icon> <span class="action-text">{{ $vuetify.lang.t('$vuetify.views.wall.addNewPost.buttons.addProblem') }}</span>
			</v-btn>
			<v-btn
				v-if="isManager && !groupId"
				height="40"
				text
				class="wall-action-btn mx-auto"
				style="padding-left: 10px !important; padding-right: 10px !important"
				@click="$refs.newPost.showDialog('announcement')"
			>
				<v-icon>$announcement</v-icon> <span class="action-text">{{ $vuetify.lang.t('$vuetify.views.wall.addNewPost.buttons.addAnnouncement') }}</span>
			</v-btn>
			</v-slide-group>
		</v-card-actions>
		<post-dialog ref="newPost" :groupId="groupId" @postAdded="postAdded" :is-group-admin="isGroupAdmin"/>
	</v-card>
</template>

<script>
import {mapGetters} from 'vuex';
import PostDialog from '@/components/wall/dialogs/PostDialog'
import Avatar from "@/components/Avatar";

export default {
	name: 'AddNewPost',
	props: {
		groupId: {
			required: false,
			type: Number
		},
		isGroupAdmin: {
			required: false,
			type: Boolean
		},
	},
	components: {
		PostDialog,
		Avatar
	},
	data() {
		return {
			fields: {
				text: null
			}
		}
	},
	computed: {
		...mapGetters({
			user: 'auth/user'
		}),
		isManager() {
			return this.user.role && this.user.role.role == 'manager';
		}
	},
	methods: {
		postAdded(post) {
			this.$emit('postAdded', post);
			console.log("Post has been added", post)
			this.$emit('postAdded', post);
		}
	}
}
</script>

<style lang="scss" scoped>
	.new-post-activator {
		padding: 8px;
		color: #afafaf;
		border: 1px solid #eaeaeb;
		border-radius: 8px;
		font-size: 14px;
		width: 100%;
		height: 60px;
	}
</style>
